<div class="container">

    <div class="col-12 col-md-10 m-auto d-flex justify-content-between">
        <div class="step" [ngClass]=" {active: step === 1, complete: step > 1 && choice !== 'none'}"
             (click)="setStep(1)">
            <span class="number">
                 <ng-container *ngIf="step===1 || choice === 'none' ">1</ng-container>
                <img *ngIf="step>1 && choice !== 'none'" [src]="imgUrl + 'tick.png'">
            </span>
            <div class="text-wrapper">
                <span class="text" *ngIf="!choice || choice === 'none'">{{'Specify actions' | translate}}</span>
                <span class="text" *ngIf="choice === 'purchase'">{{'Purchase' | translate}}</span>
                <span class="text" *ngIf="choice === 'service'">{{'Service' | translate}}</span>
            </div>
        </div>
        <div class="divider" [ngClass]=" step > 1 ? 'active' : ''"></div>
        <div class="step" [ngClass]=" {active:step === 2, complete: step >2 && selectedDevice }" (click)="setStep(2)">
            <span class="number">
                <ng-container *ngIf="step !== 3 || !selectedDevice">2</ng-container>
                <img *ngIf="step>2 && selectedDevice" [src]="imgUrl + 'tick.png'">
            </span>
            <div class="text-wrapper">
                <span class="text" *ngIf="!selectedDevice">{{'Choose device' | translate}}</span>
                <span class="text" *ngIf="selectedDevice">{{selectedDevice.name | translate}}</span>
            </div>
        </div>
        <div class="divider" [ngClass]=" step > 2 ? 'active' : ''"></div>
        <div class="step" [ngClass]=" step === 3 ? 'active' : ''" (click)="setStep(3)">
            <span class="number">3</span>
            <div class="text-wrapper">
                <span class="text">{{'Select location' | translate}}</span>
            </div>
        </div>
    </div>
</div>
